import { render, staticRenderFns } from "./ChangeControl.vue?vue&type=template&id=56a2eab4"
import script from "./ChangeControl.vue?vue&type=script&lang=js"
export * from "./ChangeControl.vue?vue&type=script&lang=js"
import style0 from "./ChangeControl.vue?vue&type=style&index=0&id=56a2eab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports